export const EMPTY_DATA = 'ERROR_EMPTY_DATA';
export const RESPONSE = 'ERROR_RESPONSE';
export const RENDER = 'ERROR_RENDER';

export default { EMPTY_DATA, RESPONSE, RENDER };
